import React, { ReactElement } from "react";
import styles from "./quickNavigation.module.scss";
import { Divider } from "@kunduz/ui";
import { gray } from "../../theme";
import { Button, Text } from "@kunduz/ui-atoms";
import { ChevronRight } from "@untitled-ui/icons-react";
import Link from "next/link";

export const QuickNavigation = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.wrapper}>
        <Divider top={0} bottom={0} color={gray[200]} />

        <div className={styles.content}>
          {props.items.map((item) => (
            <Button
              as={Link}
              href={item.href}
              key={item.label}
              variant="link"
              color="gray"
              size="lg"
              onClick={item.onClick}
            >
              {item.icon}
              <Text variant="textmd" weight="semibold">
                {item.label}
              </Text>
              <ChevronRight />
            </Button>
          ))}
        </div>
      </div>
    </section>
  );
};

interface Props {
  items: {
    label: string;
    href: string;
    icon: JSX.Element;
    onClick?: () => void;
  }[];
}
